import React , { useContext, useState } from "react";    
import { useDispatch , useSelector } from 'react-redux';
import { Link } from "react-router-dom";
import { Dialog } from 'primereact/dialog';
import { onChangeCollapsed  } from "../../redux/actions/ActionApp";
import AppContext from '../components/AppContext';
import PlanModal from './PlanModal';
import ImportFromFile from './ImportFromFile';
import LinkComponent from './LinkComponent';
import { useTranslation } from 'react-i18next';
import facebook from "../../../assets/img/facebook-boder.png";
import instagram from "../../../assets/img/instagram-boder.png";
import linkedin from "../../../assets/img/linkedin-boder.png";

// Menu component
// Shows all Respondent navigation options 
// Shows all Client navigation options
export default function Menu(props) { 

    const survey = useSelector(selector => selector.reduceRespondent.ListSurveyByRespondentId); 
    const collapsed = useSelector(selector => selector.reduceApp.collapsed);  
    const showPay = useSelector(selector => selector.reduceApp.showPay);
    const [importClient , SetImportclient] = useState(false);
    const dispatch = useDispatch();
    const myContext = useContext(AppContext);
    const { t } = useTranslation();

    const changeCollapsed = () => {
        dispatch(onChangeCollapsed());
    };

    const navigateImport = () => { 
        switch (myContext.user?.subscription_type) {
            case "Basic":
                myContext.notify6('alert' , 'Error' , t('NOTIFICATIONS.NO_IMPORT_PLAN_BASIC') );
                break;
            case "Trial":
                myContext.notify6('alert' , 'Error' , t('NOTIFICATIONS.NO_IMPORT_PLAN_TRIAL')  );
                break;
            case "None":
                myContext.notify6('alert' , 'Error' , t('NOTIFICATIONS.NO_IMPORT_RESPONDENTS')  );
                break;
            default:
                showImportClient(true);
                break;
        } 
    }

    const showImportClient = (value) => {
        SetImportclient(value);
    }

    return ( 
        <>
            <> 
            {
                myContext.user.role === "Client" || myContext.user.role === "Admin" ?
                <div className={`menu ${collapsed === true ? 'collapsed' : ''}`}>
                    <div className="menu-container">
                        <nav>
                            <ul>
                                <li> 
                                    <LinkComponent onClick={changeCollapsed}  className="trigger" />
                                </li>
                                <li>
                                    <Link to="/Survey" className="surveys">{t('MAIN.SURVEYS')}</Link>
                                </li>
                                {
                                    myContext.user.role === "Admin" ? <></> : <li>
                                        <LinkComponent onClick={navigateImport} className="import" text={t('MAIN.IMPORT_RESPONDANTS')} />
                                    </li>
                                }

                                <li className="support-li">
                                    <span className="plan">{myContext.user?.subscription_type === "None" ? t('MAIN.SPAN_SUSCRIPTION.NO_PLAN') : (t('MAIN.SPAN_SUSCRIPTION.TITLE_PLAN') + ' ' + t('MAIN.SPAN_SUSCRIPTION.PLAN.' + (myContext.user?.subscription_type).toUpperCase()))}</span>
                                    <a target="_blank" href="https://www.facebook.com/profile.php?id=100082943871215">
                                        <img src={facebook} alt="Facebook"/>
                                    </a>
                                    <a target="_blank" href="https://www.instagram.com/reflective_research/">
                                        <img src={instagram} alt="Instagram"/>
                                    </a>
                                    <a target="_blank" href="https://www.linkedin.com/in/reflective-research">
                                        <img src={linkedin} alt="LinkedIn"/>
                                    </a>
                                </li>
                            </ul>
                        </nav>
                    </div>
                </div>
                :
                <div className={`menu ${collapsed === true ? 'collapsed' : ''}`}>
                    <div className="menu-container">
                        <nav>
                            <ul>
                                <li> 
                                    <LinkComponent onClick={changeCollapsed} className="trigger" />
                                </li>
                                <li>
                                    <Link to="/Survey" className="surveys">{t('SURVEY.LIST.CLIENT.TITLE')} ({survey.length})</Link>
                                </li>
                                <li>
                                    <Link to="/Profile" className="profile">{t('PROFILE.TITLE')}</Link>
                                </li>
                                <li className="support-li">
                                    <a target="_blank" href="https://www.facebook.com/profile.php?id=100082943871215">
                                        <img src={facebook} alt="Facebook"/>
                                    </a>
                                    <a target="_blank" href="https://www.instagram.com/reflective_research/">
                                        <img src={instagram} alt="Instagram"/>
                                    </a>
                                    <a target="_blank" href="https://www.linkedin.com/in/reflective-research">
                                        <img src={linkedin} alt="LinkedIn"/>
                                    </a>
                                </li>
                            </ul>
                        </nav>
                    </div>
                </div> 
            } 
            </> 
            <Dialog visible={showPay} closable={false} showHeader={false} > 
                <PlanModal   />
            </Dialog>
            <Dialog visible={importClient} closable={false} showHeader={false}>
                <ImportFromFile  showImportClient={showImportClient} />
            </Dialog>
        </> 
     );
}
